import styled from 'styled-components';
import { Screen } from '../../../theme';

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  position: relative;
`;

interface ContainerProps {
  size?: number;
  overlap: boolean;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  transform: scale(${(p) => p.size});
  margin-left: ${(p) => (p.overlap ? '-7px' : 'auto')};
`;

interface IImageContainer {
  imageSize?: string;
}
export const ImageContainer = styled.div<IImageContainer>`
  position: relative;
  overflow: hidden;
  width: ${(p) => (p.imageSize ? p.imageSize : `30px`)};
  height: ${(p) => (p.imageSize ? p.imageSize : `30px`)};
  border-radius: 50%;
  flex-shrink: 0;
`;

export const Online = styled.div`
  border: 1px solid ${(p) => p.theme.colors.general.white};
  background-color: ${(p) => p.theme.colors.general.success};
  width: 9px;
  height: 9px;
  border-radius: 50%;
  position: absolute;
  bottom: 2px;
  right: -2px;
`;

interface IFullName {
  showFullNameBreakPoint?: Screen;
}
export const FullNameContainer = styled.div<IFullName>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  ${(p) => {
    if (p.showFullNameBreakPoint) {
      return `@media (max-width: ${p.theme.screen[p.showFullNameBreakPoint]}) {
        display: none;
      }`;
    }
  }}
`;
